/** Phone catalog — order synced from PDF tables. */
window.CasentoPhoneModels = {
  "samsung": [
    {
      "series": "Samsung Galaxy S26 Ultra",
      "magsafe": true
    },
    {
      "series": "Samsung Galaxy S26+",
      "magsafe": true
    },
    {
      "series": "Samsung Galaxy S26",
      "magsafe": true
    },
    {
      "series": "Samsung Galaxy A17 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy Z Flip7 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy S25 FE 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy S25 Edge 5G",
      "magsafe": true
    },
    {
      "series": "Samsung Galaxy A56 5G A566B",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A36 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A26 5G A266B",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy Z Flip6 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A16 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A15 A156B 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A15 A155F 4G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy S25 Ultra",
      "magsafe": true
    },
    {
      "series": "Samsung Galaxy S25+",
      "magsafe": true
    },
    {
      "series": "Samsung Galaxy A55 5G A556B",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A35 5G A356B",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A25 A256B 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A05s A057G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy Z Flip5 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A54 5G A546B A54",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A34 5G A346B",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A14",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A14 5G A146P",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy S23 Ultra 5G",
      "magsafe": true
    },
    {
      "series": "Samsung Galaxy S23+ 5G",
      "magsafe": true
    },
    {
      "series": "Samsung Galaxy A73 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A23 A236B 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy S22 Ultra 5G",
      "magsafe": true
    },
    {
      "series": "Samsung Galaxy S22+ 5G",
      "magsafe": true
    },
    {
      "series": "Samsung Galaxy S22 5G",
      "magsafe": true
    },
    {
      "series": "Samsung Galaxy A53 5G A536 A53",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A33 5G A336",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy S21 FE 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A22 A226B 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A13 5G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A13 4G A135",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A52 5G A525F",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A32 5G A326B",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A12 A125F",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy Note 20 Ultra",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A42",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy S20 FE",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A72 A725F",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A71 A715G",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy A51",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy Note 10 N970F",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy S20+ G985F",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy Note 9 N960F",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy S9 G960F",
      "magsafe": false
    },
    {
      "series": "Samsung Galaxy S8 G950F",
      "magsafe": false
    }
  ],
  "xiaomi": [
    {
      "series": "Xiaomi 17 Ultra",
      "magsafe": true
    },
    {
      "series": "Xiaomi 17",
      "magsafe": true
    },
    {
      "series": "Xiaomi Redmi Note 15 Pro+",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 15 Pro 5G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi 15C 4G",
      "magsafe": false
    },
    {
      "series": "Xiaomi 15",
      "magsafe": true
    },
    {
      "series": "Xiaomi Poco F7 Pro 5G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Poco X7 Pro 5G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 14 Pro 4G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 14 5G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 14 4G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi 14C",
      "magsafe": false
    },
    {
      "series": "Xiaomi 14 Ultra",
      "magsafe": true
    },
    {
      "series": "Xiaomi 14",
      "magsafe": true
    },
    {
      "series": "Xiaomi Redmi Note 13 Pro+ 5G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 13 Pro 5G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 13 Pro 4G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 13 5G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 13",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi 13C 4G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Poco F6",
      "magsafe": false
    },
    {
      "series": "Xiaomi 13T Pro",
      "magsafe": false
    },
    {
      "series": "Xiaomi 13T",
      "magsafe": false
    },
    {
      "series": "Xiaomi 13 Pro",
      "magsafe": true
    },
    {
      "series": "XiaoMi 13(5G)",
      "magsafe": true
    },
    {
      "series": "Xiaomi Poco F5 Pro 5G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 12 Pro+ 5G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 12 Pro 5G",
      "magsafe": false
    },
    {
      "series": "Xiaomi 12T",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 11 Pro 5G",
      "magsafe": false
    },
    {
      "series": "Xiaomi 12 Pro",
      "magsafe": false
    },
    {
      "series": "XiaoMi 12",
      "magsafe": false
    },
    {
      "series": "Xiaomi 12X",
      "magsafe": false
    },
    {
      "series": "Xiaomi 11T",
      "magsafe": false
    },
    {
      "series": "Xiaomi 11 Lite 5G",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 10 Pro",
      "magsafe": false
    },
    {
      "series": "Xiaomi Redmi Note 10S",
      "magsafe": false
    },
    {
      "series": "Xiaomi Poco F3",
      "magsafe": false
    },
    {
      "series": "Xiaomi Mi 11 Lite",
      "magsafe": false
    },
    {
      "series": "Xiaomi Poco F2 Pro",
      "magsafe": false
    },
    {
      "series": "XiaoMi15 Ultra",
      "magsafe": true
    },
    {
      "series": "XiaoMi14 Pro",
      "magsafe": true
    }
  ],
  "honor": [
    {
      "series": "Honor 400 Pro 5G",
      "magsafe": false
    },
    {
      "series": "Honor 400 5G",
      "magsafe": false
    },
    {
      "series": "Honor Magic7 Pro 5G",
      "magsafe": false
    },
    {
      "series": "Honor 200 Pro",
      "magsafe": false
    },
    {
      "series": "Honor 200",
      "magsafe": false
    },
    {
      "series": "Honor Magic6 Pro",
      "magsafe": false
    },
    {
      "series": "Honor Magic5 Pro",
      "magsafe": false
    },
    {
      "series": "Honor 90 5G",
      "magsafe": false
    },
    {
      "series": "Honor 70",
      "magsafe": false
    }
  ],
  "huawei": [
    {
      "series": "Huawei Nova 9 SE",
      "magsafe": false
    },
    {
      "series": "Huawei Nova 9",
      "magsafe": false
    },
    {
      "series": "Huawei P50",
      "magsafe": false
    },
    {
      "series": "Huawei Mate 40 Pro",
      "magsafe": false
    },
    {
      "series": "Huawei P40 Pro",
      "magsafe": false
    },
    {
      "series": "Huawei P40",
      "magsafe": false
    },
    {
      "series": "Huawei P30 Lite",
      "magsafe": false
    },
    {
      "series": "Huawei P30",
      "magsafe": false
    },
    {
      "series": "Huawei P20 Pro",
      "magsafe": false
    },
    {
      "series": "Huawei P20 Lite",
      "magsafe": false
    }
  ],
  "vivo": [
    {
      "series": "Vivo X200 Pro",
      "magsafe": false
    },
    {
      "series": "Vivo X60 Pro 5G",
      "magsafe": false
    }
  ],
  "google": [
    {
      "series": "Google Pixel 10",
      "magsafe": true
    },
    {
      "series": "Google Pixel 10 Pro",
      "magsafe": true
    },
    {
      "series": "Google Pixel 9a",
      "magsafe": false
    },
    {
      "series": "Google Pixel 9 Pro",
      "magsafe": false
    },
    {
      "series": "Google Pixel 9",
      "magsafe": false
    },
    {
      "series": "Google Pixel 8a",
      "magsafe": false
    },
    {
      "series": "Google Pixel 8 Pro",
      "magsafe": false
    },
    {
      "series": "Google Pixel 8",
      "magsafe": false
    },
    {
      "series": "Google Pixel 10 ProXL",
      "magsafe": true
    }
  ],
  "oneplus": [
    {
      "series": "OnePlus 13R 5G",
      "magsafe": false
    },
    {
      "series": "OnePlus 12 5G",
      "magsafe": false
    },
    {
      "series": "OnePlus 9",
      "magsafe": false
    }
  ],
  "oppo": [
    {
      "series": "OPPO Find X9",
      "magsafe": false
    },
    {
      "series": "OPPO Reno 7 5G",
      "magsafe": false
    },
    {
      "series": "OPPO Reno 5 5G",
      "magsafe": false
    }
  ],
  "apple": [
    {
      "series": "Apple iPhone 17e",
      "magsafe": false
    },
    {
      "series": "Apple iPhone 17 Pro Max",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 17 Pro",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 17 Air",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 17",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 16e",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 16 Pro Max",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 16 Pro",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 16 Plus",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 16",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 15 Pro Max",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 15 Pro",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 15 Plus",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 15",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 14 Plus",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 14 Pro Max",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 14 Pro",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 14",
      "magsafe": true
    },
    {
      "series": "Apple iPhone SE 2022",
      "magsafe": false
    },
    {
      "series": "Apple iPhone 13 Pro Max",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 13 Pro",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 13",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 13 mini",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 12 Pro Max",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 12 mini",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 12 Pro",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 12",
      "magsafe": true
    },
    {
      "series": "Apple iPhone SE 2020",
      "magsafe": false
    },
    {
      "series": "Apple iPhone 11 Pro Max",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 11 Pro",
      "magsafe": true
    },
    {
      "series": "Apple iPhone 11",
      "magsafe": true
    },
    {
      "series": "Apple iPhone XR",
      "magsafe": false
    },
    {
      "series": "Apple iphone XS max",
      "magsafe": false
    },
    {
      "series": "Apple iPhone X/XS",
      "magsafe": false
    },
    {
      "series": "Apple iPhone 8 Plus",
      "magsafe": false
    },
    {
      "series": "Apple iPhone 8",
      "magsafe": false
    },
    {
      "series": "Apple iPhone 7 Plus",
      "magsafe": false
    },
    {
      "series": "Apple iPhone 7",
      "magsafe": false
    }
  ]
};

window.CasentoPhoneMagSafe = {
  "Apple iPhone XR": false,
  "Apple iphone XS max": false,
  "Apple iPhone X/XS": false,
  "Apple iPhone SE 2022": false,
  "Apple iPhone SE 2020": false,
  "Apple iPhone 17 Air": true,
  "Apple iPhone 8 Plus": false,
  "Apple iPhone 8": false,
  "Apple iPhone 7 Plus": false,
  "Apple iPhone 7": false,
  "Apple iPhone 17e": false,
  "Apple iPhone 17 Pro Max": true,
  "Apple iPhone 17 Pro": true,
  "Apple iPhone 17": true,
  "Apple iPhone 16e": true,
  "Apple iPhone 16 Pro Max": true,
  "Apple iPhone 16 Pro": true,
  "Apple iPhone 16 Plus": true,
  "Apple iPhone 16": true,
  "Apple iPhone 15 Pro Max": true,
  "Apple iPhone 15 Pro": true,
  "Apple iPhone 15 Plus": true,
  "Apple iPhone 15": true,
  "Apple iPhone 14 Pro Max": true,
  "Apple iPhone 14 Pro": true,
  "Apple iPhone 14 Plus": true,
  "Apple iPhone 14": true,
  "Apple iPhone 13 Pro Max": true,
  "Apple iPhone 13 Pro": true,
  "Apple iPhone 13 mini": true,
  "Apple iPhone 13": true,
  "Apple iPhone 12 Pro Max": true,
  "Apple iPhone 12 Pro": true,
  "Apple iPhone 12 mini": true,
  "Apple iPhone 12": true,
  "Apple iPhone 11 Pro Max": true,
  "Apple iPhone 11 Pro": true,
  "Apple iPhone 11": true,
  "Samsung Galaxy A73 5G": false,
  "Samsung Galaxy A72 A725F": false,
  "Samsung Galaxy A71 A715G": false,
  "Samsung Galaxy A56 5G A566B": false,
  "Samsung Galaxy A55 5G A556B": false,
  "Samsung Galaxy A54 5G A546B A54": false,
  "Samsung Galaxy A53 5G A536 A53": false,
  "Samsung Galaxy A52 5G A525F": false,
  "Samsung Galaxy A51": false,
  "Samsung Galaxy A42": false,
  "Samsung Galaxy A36 5G": false,
  "Samsung Galaxy A35 5G A356B": false,
  "Samsung Galaxy A34 5G A346B": false,
  "Samsung Galaxy A33 5G A336": false,
  "Samsung Galaxy A32 5G A326B": false,
  "Samsung Galaxy A26 5G A266B": false,
  "Samsung Galaxy A25 A256B 5G": false,
  "Samsung Galaxy A23 A236B 5G": false,
  "Samsung Galaxy A22 A226B 5G": false,
  "Samsung Galaxy A17 5G": false,
  "Samsung Galaxy A16 5G": false,
  "Samsung Galaxy A15 A156B 5G": false,
  "Samsung Galaxy A15 A155F 4G": false,
  "Samsung Galaxy A14 5G A146P": false,
  "Samsung Galaxy A14": false,
  "Samsung Galaxy A13 5G": false,
  "Samsung Galaxy A13 4G A135": false,
  "Samsung Galaxy A12 A125F": false,
  "Samsung Galaxy A05s A057G": false,
  "Samsung Galaxy Note 9 N960F": false,
  "Samsung Galaxy Note 20 Ultra": false,
  "Samsung Galaxy Note 10 N970F": false,
  "Samsung Galaxy S9 G960F": false,
  "Samsung Galaxy S8 G950F": false,
  "Samsung Galaxy S26+": true,
  "Samsung Galaxy S26 Ultra": true,
  "Samsung Galaxy S26": true,
  "Samsung Galaxy S25+": true,
  "Samsung Galaxy S25 Ultra": true,
  "Samsung Galaxy S25 FE 5G": false,
  "Samsung Galaxy S25 Edge 5G": true,
  "Samsung Galaxy S23+ 5G": true,
  "Samsung Galaxy S23 Ultra 5G": true,
  "Samsung Galaxy S22+ 5G": true,
  "Samsung Galaxy S22 Ultra 5G": true,
  "Samsung Galaxy S22 5G": true,
  "Samsung Galaxy S21 FE 5G": false,
  "Samsung Galaxy S20+ G985F": false,
  "Samsung Galaxy S20 FE": false,
  "Samsung Galaxy Z Flip7 5G": false,
  "Samsung Galaxy Z Flip6 5G": false,
  "Samsung Galaxy Z Flip5 5G": false,
  "Xiaomi Mi 11 Lite": false,
  "Xiaomi 11T": false,
  "Xiaomi 11 Lite 5G": false,
  "Xiaomi Poco X7 Pro 5G": false,
  "Xiaomi Poco F7 Pro 5G": false,
  "Xiaomi Poco F6": false,
  "Xiaomi Poco F5 Pro 5G": false,
  "Xiaomi Poco F3": false,
  "Xiaomi Poco F2 Pro": false,
  "Xiaomi Redmi 15C 4G": false,
  "Xiaomi Redmi 14C": false,
  "Xiaomi Redmi 13C 4G": false,
  "Xiaomi Redmi Note 15 Pro+": false,
  "Xiaomi Redmi Note 15 Pro 5G": false,
  "Xiaomi Redmi Note 14 Pro 4G": false,
  "Xiaomi Redmi Note 14 5G": false,
  "Xiaomi Redmi Note 14 4G": false,
  "Xiaomi Redmi Note 13 Pro+ 5G": false,
  "Xiaomi Redmi Note 13 Pro 5G": false,
  "Xiaomi Redmi Note 13 Pro 4G": false,
  "Xiaomi Redmi Note 13 5G": false,
  "Xiaomi Redmi Note 13": false,
  "Xiaomi Redmi Note 12 Pro+ 5G": false,
  "Xiaomi Redmi Note 12 Pro 5G": false,
  "Xiaomi Redmi Note 11 Pro 5G": false,
  "Xiaomi Redmi Note 10S": false,
  "Xiaomi Redmi Note 10 Pro": false,
  "Xiaomi 17 Ultra": true,
  "Xiaomi 17": true,
  "XiaoMi15 Ultra": true,
  "Xiaomi 15": true,
  "Xiaomi 14 Ultra": true,
  "XiaoMi14 Pro": true,
  "Xiaomi 14": true,
  "Xiaomi 13T Pro": false,
  "Xiaomi 13T": false,
  "Xiaomi 13 Pro": true,
  "XiaoMi 13(5G)": true,
  "Xiaomi 12X": false,
  "Xiaomi 12T": false,
  "Xiaomi 12 Pro": false,
  "XiaoMi 12": false,
  "Honor Magic7 Pro 5G": false,
  "Honor Magic6 Pro": false,
  "Honor Magic5 Pro": false,
  "Honor 90 5G": false,
  "Honor 70": false,
  "Honor 400 Pro 5G": false,
  "Honor 400 5G": false,
  "Honor 200 Pro": false,
  "Honor 200": false,
  "Huawei Mate 40 Pro": false,
  "Huawei Nova 9 SE": false,
  "Huawei Nova 9": false,
  "Huawei P50": false,
  "Huawei P40 Pro": false,
  "Huawei P40": false,
  "Huawei P30 Lite": false,
  "Huawei P30": false,
  "Huawei P20 Pro": false,
  "Huawei P20 Lite": false,
  "Vivo X60 Pro 5G": false,
  "Vivo X200 Pro": false,
  "Google Pixel 9a": false,
  "Google Pixel 9 Pro": false,
  "Google Pixel 9": false,
  "Google Pixel 8a": false,
  "Google Pixel 8 Pro": false,
  "Google Pixel 8": false,
  "Google Pixel 10 ProXL": true,
  "Google Pixel 10 Pro": true,
  "Google Pixel 10": true,
  "OnePlus 9": false,
  "OnePlus 13R 5G": false,
  "OnePlus 12 5G": false,
  "OPPO Reno 7 5G": false,
  "OPPO Reno 5 5G": false,
  "OPPO Find X9": false
};
